<template>
  <span v-if="texto" class="rm-placa" :class="{ 'rm-placa-chica': chica }" data-testid="placa">
    <small class="rm-placa-estado" aria-hidden="true">{{ estado }}</small>
    <span class="rm-placa-numero"><span class="rm-placa-sr">Placa </span>{{ texto }}</span>
  </span>
  <span v-else class="rm-placa-vacia" data-testid="placa">Sin placa</span>
</template>

<script>
/*
 * AppPlaca — placa del auto con el estilo de las placas de Sinaloa: fondo
 * claro, marco oscuro, el estado arriba y el número en monoespaciada.
 * Se muestra como está guardada (en mayúsculas). El lector de pantalla
 * escucha "Placa VNP-482-B"; el nombre del estado es decorativo.
 *
 * Uso: <AppPlaca placa="VNP-482-B" /> o <AppPlaca :placa="auto.placa" chica />
 */
export default {
  name: 'AppPlaca',
  props: {
    placa: { type: String, default: '' },
    chica: { type: Boolean, default: false },
    estado: { type: String, default: 'SINALOA' },
  },
  computed: {
    texto() {
      return String(this.placa ?? '').trim().replace(/\s+/g, ' ').toLocaleUpperCase('es-MX')
    },
  },
}
</script>

<style scoped>
.rm-placa {
  display: inline-grid;
  flex: none;
  justify-items: center;
  padding: 2px 10px 4px;
  border: 2px solid #0b1b2e;
  border-radius: 7px;
  background: #fff;
  color: #0b1b2e;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
}
.rm-placa-estado {
  display: block;
  font: 700 8px/1.3 Inter, Roboto, sans-serif;
  letter-spacing: 0.2em;
}
.rm-placa-numero {
  display: block;
  font: 600 17px/1 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.06em;
}
.rm-placa-chica {
  padding: 1px 7px 3px;
  border-width: 1.5px;
  border-radius: 5px;
}
.rm-placa-chica .rm-placa-estado {
  font-size: 6px;
}
.rm-placa-chica .rm-placa-numero {
  font-size: 13px;
}
.rm-placa-vacia {
  display: inline-block;
  color: #607187;
  font-size: 13px;
  white-space: nowrap;
}
.rm-placa-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
</style>
